<!-- Component for displaying the Everplans item in the cart -->
<template>
	<div
		class="mt-2.5 mb-2"
		v-if="mockProductEverplans"
		v-auto-animate
	>
		<SwipeableToggle
			target-class="hover:bg-primary-50"
			v-model="isEverplansIncluded"
		>
			<div
				class="grid w-full grid-cols-[minmax(0,1fr)_max-content] grid-rows-1 items-center gap-4 overflow-hidden"
			>
				<div class="flex flex-1 items-center">
					<p
						class="text-primary-700 text-sm font-bold"
						:class="{
							'text-secondary-400! line-through': !isEverplansIncluded,
						}"
					>
						Everplans
					</p>
				</div>
				<div
					class="text-sm text-slate-500"
					:class="{
						'text-secondary-300! line-through': !isEverplansIncluded,
					}"
				>
					{{
						includesFreeEverplansPremium
							? t('reviewSlide.included')
							: formatPrice(everplansPrice)
					}}
				</div>
			</div>
		</SwipeableToggle>
	</div>
</template>

<script setup lang="ts">
import Plan from '@/classes/Plan'
import SwipeableToggle from '@/components/common/SwipeableToggle.vue'
import { usePresentationLocale } from '@/i18n'
import { useMerchandise } from '@/mixins/merchandise'
import { useCartStore } from '@/stores/cart'
import { computed, type PropType } from 'vue'

const { formatPrice, mockProductEverplans, getEverplansPrice } =
	useMerchandise()
const cartStore = useCartStore()
const { t } = usePresentationLocale()
const emit = defineEmits<{
	(e: 'update:everplansIncluded', everplansIncluded: boolean, plan: Plan): void
}>()

const props = defineProps({
	plan: {
		type: Object as PropType<Plan>,
		required: true,
	},
})

const includesFreeEverplansPremium = computed(() => {
	return cartStore.cart[props.plan.id]?.includesFreeEverplansPremium ?? false
})

const everplansPrice = computed(() => {
	return getEverplansPrice(props.plan.id)
})

const isEverplansIncluded = computed({
	get() {
		return props.plan?.everplansIncluded
	},
	set(newValue) {
		emit('update:everplansIncluded', newValue, props.plan)
	},
})
</script>
